import { render, staticRenderFns } from "./GoliaWaypointSearch.vue?vue&type=template&id=a5f64810"
import script from "./GoliaWaypointSearch.vue?vue&type=script&lang=js"
export * from "./GoliaWaypointSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports